import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const GeneralIncidentsPerDistrict = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="DISTRICT" disaggregation = "validity"/>
        </>
    
  )
}

export default GeneralIncidentsPerDistrict